/**
 * ElementUI fixed 列与主表分行渲染；多行换行 / Windows 缩放时
 * 行高亚像素取整不一致会导致格线错位。按主表行高对齐固定列。
 */
export function syncElTableFixedRows(table: any): void {
  if (!table || !table.$el) return
  if (typeof table.doLayout === 'function') {
    table.doLayout()
  }
  const root = table.$el as HTMLElement
  const bodyRows = root.querySelectorAll(
    '.el-table__body-wrapper > table > tbody > tr'
  )
  const sync = (selector: string) => {
    const fixedRows = root.querySelectorAll(selector)
    fixedRows.forEach((fixedRow, i) => {
      const bodyRow = bodyRows[i] as HTMLElement | undefined
      if (!bodyRow || !(fixedRow instanceof HTMLElement)) return
      const h = Math.ceil(bodyRow.getBoundingClientRect().height)
      fixedRow.style.height = `${h}px`
      fixedRow.querySelectorAll('td').forEach((td) => {
        ;(td as HTMLElement).style.height = `${h}px`
      })
    })
  }
  sync('.el-table__fixed-right .el-table__fixed-body-wrapper > table > tbody > tr')
  sync('.el-table__fixed .el-table__fixed-body-wrapper > table > tbody > tr')
}

/** $nextTick + rAF 后再同步，等单元格换行完成 */
export function scheduleElTableFixedSync(
  vm: { $nextTick: (fn: () => void) => void; $refs: Record<string, any> },
  refName: string
): void {
  vm.$nextTick(() => {
    requestAnimationFrame(() => {
      syncElTableFixedRows(vm.$refs[refName])
    })
  })
}
